import { Component, OnInit, NgZone, ChangeDetectorRef } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';


@Component({
  standalone: false,
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['../../shared/css/auth.css', './forgot-password.component.scss'],
})

export class ForgotPasswordComponent implements OnInit {
  constructor(public authService: AuthService, private matSnackBar: MatSnackBar, private router: Router, private ngZone: NgZone, private cdr: ChangeDetectorRef) {}
  isLoadingResults: boolean = false;

  hasFinishedResetRequest: boolean = false;

  ngOnInit() {}

  email = new FormControl('', [Validators.required, Validators.email]);

  forgotPassword() {
    this.ngZone.run(async () => {
      try {
        this.isLoadingResults = true;
        this.cdr.markForCheck();
        await this.authService.forgotPassword(this.email.value!);
        this.isLoadingResults = false;
        this.hasFinishedResetRequest = true;
        this.cdr.markForCheck();
      } catch (error: any) {
        this.isLoadingResults = false;
        this.cdr.markForCheck();
        if (error?.code === "auth/user-not-found") {
          this.matSnackBar.open("User with this email address doesn't exist. Create an account first.", "OK");
        } else {
          this.matSnackBar.open(error?.message || "An error occurred", "OK");
        }
      }
    });
  }

  getErrorMessage() {
    if (this.email.hasError('required')) {
      return 'You must enter a value';
    }
    if (this.email.hasError('email')) {
      return 'You must enter a valid email address';
    }
    return '';
  }

  isFormValid() {
    return !this.email.invalid;
  }

  onKeyDown(event: any) {
    if (event.keyCode === 13 && this.isFormValid()) {
      this.forgotPassword();
    }
  }

  onCancelClick() {
    this.router.navigate(['/sign-in']);
  }
}
